import { EnvSettingsDto, EnvSettingsDtoValuePrimitiveType, EnvSettingsDtoValueType } from './types'

export const parseTypedEnvSettings = (settings: Array<EnvSettingsDto>): Array<EnvSettingsDto<EnvSettingsDtoValueType>> => {
  if (!Array.isArray(settings)) {
    console.error('[parseTypedEnvSettings] expected array, got:', settings)
    return []
  }
  return settings.map((s) => {
    const value = parseTypedEnvSettingValue(s.value)
    return { ...s, value }
  })
}

const parseTypedEnvSettingValue = (value: string) => {
  if (!value) {
    return null
  }
  if (value.startsWith('[') && value.endsWith(']')) {
    return (JSON.parse(value) as Array<string>).map((v) => parseTypedEnvSettingValuePrimitive(v))
  }
  return parseTypedEnvSettingValuePrimitive(value)
}

const parseTypedEnvSettingValuePrimitive = (value: string): EnvSettingsDtoValuePrimitiveType => {
  if (value === 'true') {
    return true
  } else if (value === 'false') {
    return false
  } else if (!value) {
    return null
  } else if (/^-?\d+$/.test(value)) {
    // Check if it's a valid integer (no decimal point, no non-numeric characters)
    return parseInt(value)
  } else if (/^-?\d*\.\d+$/.test(value)) {
    // Check if it's a valid float (has decimal point, no non-numeric characters)
    return parseFloat(value)
  }
  return value
}
